import React, { useCallback, useRef } from "react";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import * as Icon from 'react-bootstrap-icons';
import { Button } from "react-bootstrap";
import InviteUserModal from "./InviteUserModal";
import EditUserModal from "./EditUserModal";
import { getUsersApi, deleteUserApi } from "../services/api";
import ConfirmModal from "../Components/ConfirmModal";
import UserTable from "./UserTable";
import "../assets/styles/UserManagment.scss";

const UserManagment = (): JSX.Element => {
    const [editUser, setEditUser] = useState({
        userId: "", emailConfirmed: false, firstName: "", lastName: "", email: "", role: "", isActive: false
    });
    const [rowData, setRowData] = useState();
    const [modalShow, setModalShow] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);
    const [filterChanged, setFilterChanged] = useState(false);
    const gridRef = useRef();

    useEffect(() => {
        onGridReady();
    }, []);

    const onGridReady = () => {
        getUsersApi().then((response) => {
            setRowData(response);
        }).catch((err) => {
            toast.error(err.toString());
        });
    };
    const customComparator = (valueA, valueB) => {  //sort values by converting it into lowercase
        return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
    };

    const columnDefs = [
        {
            headerName: 'First Name',
            field: 'firstName', cellClass: "font-14-400 row-font-color",
            cellRenderer: params =>
                params.value.charAt(0).toUpperCase() + params.value.slice(1).toLowerCase(),
            comparator: customComparator,
            filter: true
        },
        {
            headerName: 'Last Name', field: 'lastName', cellClass: "font-14-400 row-font-color",
            cellRenderer: params =>
                params.value !== null && params.value.charAt(0).toUpperCase() + params.value.slice(1).toLowerCase(),
            comparator: customComparator, filter: true
        },
        {
            headerName: 'Email', field: 'email', cellClass: "font-14-400 row-font-color",
            minWidth: 200, resizable: true, comparator: customComparator, filter: true
        },
        {
            headerName: 'Role', field: 'role', cellClass: "font-14-400 row-font-color",
            minWidth: 120, comparator: customComparator, cellRenderer: params =>
                params.value.charAt(0).toUpperCase() + params.value.slice(1).toLowerCase(), filter: true
        },
        {
            headerName: "Action", field: "action",
            cellRenderer: function (params) {
                return <button onClick={() => { setEditModal(true); setEditUser(params.data); }} className="btn btn-link p-0 m-0" data-testid="editUserButton">Edit</button>
            }, filter: false
        }
    ];

    const clearFilters = useCallback(() => {
        // eslint-disable-next-line
        const node = gridRef.current as any;
        node.api.setFilterModel(null);
        setTimeout(() => setFilterChanged(false));
    }, []);

    const showConfirmModal = () => {
        setEditModal(false);
        setConfirmModal(true);
    };

    const deleteUser = () => {
        deleteUserApi({ email: editUser.email }).then(() => {
            onGridReady();
            setConfirmModal(false);
            toast.success("User deleted successfully");
        }).catch((err) => {
            setConfirmModal(false);
            toast.error(err.toString());
        });
    };

    return (
        <div className="container mt-3 p-0" id="user-management" data-testid="userTable">
            <div className="row pb-2 position-relative ">
                <div className="col-8">
                    <h4 className="ps-0 pt-2">User List</h4>
                </div>
                <div className="col-4 text-center mobile-hide">
                    {filterChanged &&
                        <Button id="reset-btn" data-testid="reset-btn" variant="secondary" className="btn-invite float-right font-12-500" onClick={clearFilters} >
                            Reset Filters
                        </Button>
                    }
                    <Button
                        type="button"
                        id="inviteUserBtn"
                        data-testid="inviteUserBtn"
                        className="btn-primary font-12-500 btn-invite position-absolute end-0"
                        onClick={() => setModalShow(true)}
                    >
                        + Invite New User
                    </Button>
                </div>
                <div className="col desktop-hide text-end my-auto" >
                    {filterChanged &&
                        <button id="reset-btn" data-testid="reset-btn" className='btn btn-secondary btn-sm' onClick={clearFilters}>
                            <Icon.ArrowClockwise className='me-1' />
                            Reset
                        </button>
                    }
                    <button type="button" id="btn btn-invite"
                        data-testid="inviteUserBtn" className="btn btn-primary btn-sm ms-2"
                        onClick={() => setModalShow(true)}>
                        + Invite &nbsp;
                    </button>
                </div>
            </div>
            <UserTable
                gridRef={gridRef}
                rowData={rowData}
                columnDefs={columnDefs}
                onGridReady={onGridReady}
                filterChangedFn={() => setFilterChanged(true)}
            />
            {/* <div className="row">{renderUsersTable()}</div> */}

            <InviteUserModal refreshUsers={onGridReady} show={modalShow} onHide={() => setModalShow(false)} />
            <EditUserModal user={editUser} refreshUsers={onGridReady} show={editModal} onHide={() => setEditModal(false)} showConfirmModal={showConfirmModal} />
            <ConfirmModal id="deleteUserConfirmModal" data-testid="deleteUserConfirmModal" message="Are you sure you want to delete this user?" confirm={deleteUser} show={confirmModal} onHide={() => setConfirmModal(false)} />
        </div>
    );
}

export default UserManagment;